import React, { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PersonalInfoStore } from './personal-info';
import { ContactInfoStore } from './contact-info';
import { useWorkExperience } from './work-experience';
import { useEducationInfo } from './education-info';
import { useAdditionalInfo } from './additonal-info';
import { CandidateEditProfileDto } from 'candidate/types';
import { CandidateApiService } from 'candidate/CandidateApiService';
import { CreateResumeStore } from './create-resume.store';
import { DesiredPositionStore } from './desired-position';

const CreateResumeContext = React.createContext<CreateResumeStore | null>(null);

export const CreateResumeProvider = ({
  children,
  initValue,
}: {
  children: ReactNode;
  initValue?: CandidateEditProfileDto;
}) => {
  const [store] = React.useState<CreateResumeStore>(
    () =>
      new CreateResumeStore(
        new PersonalInfoStore(),
        new ContactInfoStore(),
        new DesiredPositionStore()
      )
  );
  const workExperienceCtx = useWorkExperience();
  const educationInfoCtx = useEducationInfo();
  const additionalInfoCtx = useAdditionalInfo();

  if (initValue) {
    // personalInfoCtx.set(initValue);
    // contactInfoCtx.set(initValue);
    // desiredPositionCtx.set(initValue);
    // workExperienceCtx.set(initValue);
    // educationInfoCtx.set(initValue);
    // additionalInfoCtx.set(initValue);
  }

  useEffect(() => {
    CandidateApiService.candidatesEditProfile(null)
      .then((res) => {
        if (res.status === 200) {
          store.contactInfoStore.linkedMessengers.setMessengerTypes(
            res.response.messengers
          );
          store.contactInfoStore.linkedSocials.setSocialsTypes(res.response.socials);
          store.desiredPosition.update(res.response);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }, []);

  const submit = () => {};

  return (
    <CreateResumeContext.Provider value={store}>{children}</CreateResumeContext.Provider>
  );
};

export const useCreateResumeContext = () => {
  const ctx = React.useContext(CreateResumeContext);
  if (!ctx) {
    throw new Error('useCreateResumeContext must be used inside CreateResumeProvider');
  }
  return ctx;
};

// const requestPayload = {
//     city: {
//         value: 134,
//         label: 'Ужгород, Закарпатська область',
//     },
//     gender: '0',
//     country: 5,
//     birthday: '2024-11-14',
//     position: {
//         value: null,
//         label: 'резюме 04.03.2025',
//     },
//     last_name: 'Білецька',
//     work_type: [
//         {
//             value: '1',
//             label: 'Повна зайнятість',
//         },
//         {
//             value: '2',
//             label: 'Часткова зайнятість',
//         },
//         {
//             value: '4',
//             label: 'Змінний графік',
//         },
//     ],
//     first_name: 'Наталя',
//     salary_max: '',
//     salary_min: 45000,
//     middle_name: 'Петрівна',
//     email_address: 'nata.biletskaya123@gmail.com',
//     video_cv_link: '',
//     about_yourself: '<p>про себе asdfsfsd</p>',
//     contact_number: '+380937093170',
//     driver_license: 1,
//     desired_country: 5,
//     salary_currency: 1,
//     contact_number_2: '',
//     contact_number_3: '',
//     skills: [
//         {
//             value: 429,
//             label: '1C',
//         },
//         {
//             value: 1798,
//             label: "1.Навички роботи з комп'ютером ПК на рівні упевненого користувача: Microsoft Office, 1С-7",
//         },
//         {
//             value: 1799,
//             label: '2.Знання законодавчої бази України, яка регламентує діяльність правоохоронних органів і охоронних структур, нормативно-правових актів у сфері цивільно-правових, кримінально-процесуальних, трудових і адміністративних стосунків.',
//         },
//     ],
//     relocations: [
//         {
//             value: 115,
//             label: 'Київ, Київська область',
//         },
//         {
//             value: 134,
//             label: 'Ужгород, Закарпатська область',
//         },
//     ],
//     driver_category: [
//         {
//             value: 3,
//             label: 'B1',
//         },
//         {
//             value: 6,
//             label: 'C',
//         },
//         {
//             value: 5,
//             label: 'C1',
//         },
//         {
//             value: 2,
//             label: 'A',
//         },
//         {
//             value: 10,
//             label: 'C1E',
//         },
//     ],
//     company_blacklist: [],
//     company_whitelist: [],
//     languages: [
//         {
//             lng: 57,
//             lng_skill: '8',
//         },
//     ],
//     social_links: [
//         {
//             link: 'https://www.facebook.com/profile.php?id=100069434383690',
//             type: 'Facebook',
//         },
//     ],
//     visibility: {
//         value: '0',
//         label: 'не видно нікому',
//     },
//     messenger_links: [
//         {
//             link: null,
//             type: null,
//         },
//     ],
//     desired_category: [
//         {
//             category: {
//                 value: 8,
//                 label: 'Безпека',
//             },
//             sub_category: [
//                 {
//                     value: 1736,
//                     label: 'Інше',
//                 },
//                 {
//                     value: 1519,
//                     label: 'Інкасатор',
//                 },
//             ],
//         },
//     ],
//     additional_educations: [
//         {
//             id: 90029753,
//             certificate: 'https://grc.net.ua/files/certificates/1587-6E7Q.jpeg',
//             course_link: null,
//             course_name: null,
//             institution_add: null,
//             diploma_type: null,
//             from_month_edu_add: null,
//             from_year_edu_add: null,
//             still_learning_add: false,
//             to_month_edu_add: null,
//             to_year_edu_add: null,
//         },
//     ],
//     educations: [
//         {
//             id: 332614118,
//             edu_type: '3',
//             institution: {
//                 value: null,
//                 label: 'Киевский институт бизнесса и технологий',
//             },
//             faculty: {
//                 value: null,
//                 label: 'Финансы и управление',
//             },
//             specialty: {
//                 value: null,
//                 label: '',
//             },
//             from_month_edu: '3',
//             from_year_edu: '1992',
//             to_month_edu: '2',
//             to_year_edu: '2020',
//             still_learning: false,
//         },
//     ],
//     experiences: [
//         {
//             id: 1440679705,
//             exp_country: 5,
//             exp_city: {
//                 value: 115,
//                 label: 'Київ',
//             },
//             position: {
//                 value: 2022,
//                 label: 'Торговий представник',
//             },
//             organization: {
//                 value: 610887,
//                 label: 'Imperial Tobacco Ukraine',
//             },
//             achievements:
//                 '<p><span lang="RU">Imperial Tobacco Ukraine, Київ (Табачные\n    изделия,продажа):<br>\n    - посещение ТТ согласно маршрутов;<br>\n    -проведение переговоров с клиентами(действующими, а также подключение новых) ;<br>\n    -заключение договоров согласно шаблонов компании ;<br>\n    -консультирование клиентов о продукте;<br>\n    -обучение работы с программами лояльности ;<br>\n    -ведение отчётности ;<br>\n    -принятие решений по размещению продукции(мерчендайзинг) выгодной для компании;<br>\n    -управление, курирование работы техников, мерчендайзеров.<br>\n    <br>\n</span></p>',
//             industry: [
//                 {
//                     value: '14',
//                     label: 'Будматеріали',
//                 },
//                 {
//                     value: '428',
//                     label: 'Авіаційна, гелікоптерна, аерокосмічна промисловість',
//                 },
//                 {
//                     value: '431',
//                     label: 'Двигуни (виробництво)',
//                 },
//             ],
//             from_month_exp: 2,
//             from_year_exp: 2023,
//             to_month_exp: null,
//             to_year_exp: null,
//             still_working: 1,
//         },
//     ],
// };
